import { useEffect } from 'react'
import { Table, message, Select } from 'antd'
import { AppDrawer } from '@/components/YhDrawer'
import { ISelectOption } from '@/components/YhFormBox/Types'
import { creditFlagDs } from '@/views/account/AccountService'
import { contractManageService } from "@/views/contract/manage/ContractManageService";
import { Form, Space } from 'antd'
import { MinusCircleOutlined } from '@ant-design/icons'
import { useDetailModel } from '@/views/account/customerManage/view/detail/detailModel'
import { beService } from '@/views/account/../base/be/beService'
import appService from '@/views/account/../base/app/appService'
import { useAccountModel } from '@/views/account/customerManage/view/detail/account/accountModel'
import { dictService } from '@/views/account/../base/dict/dictService'
import { IFMSInitAccountForm } from '@/views/account/AccountTypes'
import { CreditFlagEnum } from '@/types/FmsEnums'
import { DictCodeEnmu } from '@/types/FmsDictEnums'
import { useGlobalModel } from '@/model/globalModel'
import { useLockFn } from 'ahooks'
import { ColumnsType } from "antd/lib/table";
import { summaryModel } from "./summaryModel";
import { ContractResult } from "@/views/contract/manage/ContractManageTypes";

export const InitAccountDrawer = () => {
    const [form] = Form.useForm()
    const { accountTypeDs, setAccountType } = useAccountModel()

    const {
        initAccountVisible, setInitAccountVisible,
        selectedData, setSelectedData,
        selectedRowKeys, setSelectedRowKeys,
        resetSearchParam,
    } = summaryModel()

    const {
        beDs,
        setBeDs,
        appDs,
        setAppDs,
    } = useDetailModel((model) => [model.orgDs, model.beDs, model.appDs])
    const {
        user: { shopCode, shopName },
        beShopDs,
        userBranch,
    } = useGlobalModel()


    useEffect(() => {
        if (initAccountVisible) {
            beService.beDs({}).then((ds) => setBeDs(ds))
            appService.appDs({}).then((ds) => setAppDs(ds))
            dictService.dictItemDs(DictCodeEnmu.ACC_TYPE).then((ds) => setAccountType(ds))
        } else {
            form.resetFields()
        }
    }, [initAccountVisible])

    const onOk = useLockFn(async () => {
        await form.validateFields().then(async (res) => {
            let result = res
            let mdCustomers: { "code": string, "name": string }[] = selectedData?.map(item => ({
                code: item.partnerCode ?? "",
                name: item.partnerName ?? ""
            }))
            await contractManageService.monthAccountOpen({
                "branch": userBranch,
                "shopCode": shopCode,
                "shopName": shopName,
                "beCode": result.fmsAccounts[0].beCode,
                "beName": result.fmsAccounts[0].beName,
                "mdCustomers": mdCustomers
            }).then((res) => {
                if (res) {
                    resetSearchParam();
                    onCancel()
                    message.success(res.retData)
                }
            })
        })
    })

    const onCancel = () => {
        setInitAccountVisible(false)
    }

    //设置对应字段的名称
    const setFormFmsAccounts = (index: number, fieldName: string, fieldVal: ISelectOption) => {
        let fromVal: IFMSInitAccountForm = form.getFieldsValue()
        let newVal = fromVal.fmsAccounts[index]

        //判断当 更改授信类型时， 重置账户类型重新选择
        if (fieldName === 'creditFlag') {
            fromVal.fmsAccounts.splice(index, 1, { ...newVal, ['accountTypeCode']: undefined })
        } else {
            fromVal.fmsAccounts.splice(index, 1, { ...newVal, [fieldName]: fieldVal.label })
        }
        form.setFieldsValue(fromVal)
    }

    const columns: ColumnsType<ContractResult> = [
        {
            title: '序号',
            width: 66,
            align: "center",
            fixed: "left",
            render: (t, r, i) => i + 1
        },
        {
            align: "center",
            title: '客户名称',
            dataIndex: 'partnerName',
        },
        {
            align: "center",
            title: '客户编码',
            dataIndex: 'partnerCode',
        },
        {
            title: '操作',
            width: 80,
            align: "center",
            render: (text, record) => <MinusCircleOutlined
                className="dynamic-delete-button"
                onClick={() => {
                    setSelectedRowKeys(selectedRowKeys?.filter(item => item !== record.partnerCode));
                    setSelectedData(selectedData?.filter(item => item.partnerCode !== record.partnerCode));
                }}
            />
        }
    ]

    return (
        <AppDrawer
            {...{
                title: '账户初始化',
                width: 900,
                visible: initAccountVisible,
                closable: true,
                onOk,
                onCancel,
                showFooter: true,
            }}
        >
            <Form
                form={form}
                autoComplete="off"
                initialValues={{
                    fmsAccounts: [
                        {
                            branch: userBranch,
                            accountTypeCode: 'account-type.credit-month',
                            accountTypeName: '月结账户',
                            shopCode,
                            shopName,
                            beCode: undefined,
                            beName: undefined,
                            creditFlag: CreditFlagEnum.CREDIT,
                        },
                    ],
                }}
            >
                <Form.List name="fmsAccounts">
                    {(fields, { add, remove }) => {
                        return (
                            <>
                                {fields.map((field, index) => (
                                    <Space key={field.key} style={{ display: 'flex' }} align="baseline">
                                        <Form.Item
                                            {...field}
                                            name={[field.name, 'branch']}
                                            fieldKey={[field.fieldKey, 'branch']}
                                            rules={[{ required: true, message: '请选择分支' }]}
                                        >
                                            <Select disabled style={{ width: 160 }} placeholder="系统分支" options={appDs} />
                                        </Form.Item>
                                        <Form.Item
                                            {...field}
                                            name={[field.name, 'creditFlag']}
                                            fieldKey={[field.fieldKey, 'creditFlag']}
                                            rules={[{ required: true, message: '请选择授信类型' }]}
                                        >
                                            <Select
                                                disabled
                                                style={{ width: 160 }}
                                                placeholder="授信类型"
                                                options={creditFlagDs()}
                                                onChange={(value, option) => {
                                                    option && setFormFmsAccounts(index, 'creditFlag', option as ISelectOption)
                                                }}
                                            />
                                        </Form.Item>
                                        <Form.Item
                                            {...field}
                                            name={[field.name, 'accountTypeCode']}
                                            fieldKey={[field.fieldKey, 'accountTypeCode']}
                                            rules={[{ required: true, message: '请选择账户类型' }]}
                                        >
                                            <Select
                                                disabled
                                                style={{ width: 160 }}
                                                placeholder="账户类型"
                                                options={(() => {
                                                    let fromVal: IFMSInitAccountForm = form.getFieldsValue()
                                                    if (!fromVal.fmsAccounts) return []
                                                    //在选择授信账户为记账时， 只展示 授信及月结，  否则返回其它
                                                    return accountTypeDs.filter((item) => item.value === 'account-type.credit-month')
                                                })()}
                                                onChange={(value, option) => {
                                                    option && setFormFmsAccounts(index, 'accountTypeName', option as ISelectOption)
                                                }}
                                            />
                                        </Form.Item>
                                        <Form.Item
                                            {...field}
                                            name={[field.name, 'beCode']}
                                            fieldKey={[field.fieldKey, 'beCode']}
                                            rules={[{ required: true, message: '请选择账户实体' }]}
                                        >
                                            <Select
                                                style={{ width: 160 }}
                                                placeholder="账户实体"
                                                options={beShopDs}
                                                onChange={(value, option) => {
                                                    option && setFormFmsAccounts(index, 'beName', option as ISelectOption)
                                                }}
                                            />
                                        </Form.Item>
                                        <Form.Item
                                            {...field}
                                            name={[field.name, 'shopCode']}
                                            fieldKey={[field.fieldKey, 'shopCode']}
                                            rules={[{ required: true, message: '请选择组织机构' }]}
                                        >
                                            <Select
                                                disabled
                                                style={{ width: 160 }}
                                                placeholder="从属门店"
                                                options={[{ label: shopName, value: shopCode }]}
                                                onChange={(value, option) => {
                                                    option && setFormFmsAccounts(index, 'shopName', option as ISelectOption)
                                                }}
                                            />
                                        </Form.Item>

                                        {fields.length > 1 ? (
                                            <MinusCircleOutlined className="dynamic-delete-button" onClick={() => remove(field.name)} />
                                        ) : null}
                                    </Space>
                                ))}
                            </>
                        )
                    }}
                </Form.List>
            </Form>
            <Table
                columns={columns}
                dataSource={selectedData}
                pagination={false}
            />
        </AppDrawer>
    )
}
